import React, { useState, useEffect } from "react";
import { AiFillStar } from "react-icons/ai";
import laptopbanner from "../assets/laptopbanner.jpg";
import shoebanner from "../assets/shoebanner.jpg";
import {
  MdOutlineAddShoppingCart,
  MdOutlineRemoveShoppingCart,
} from "react-icons/md";
import {
  FcFlashOn,
  FcMultipleDevices,
  FcAdvertising,
  FcPortraitMode,
  FcInTransit,
} from "react-icons/fc";
import { useNavigate } from 'react-router-dom';

const Products = (props) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://dummyjson.com/products");
        const data = await response.json();
        setProducts(data.products);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);


  const navigate = useNavigate();
  const productPage = (id) => {
    // console.log('cart',cart)
    navigate(`/productdisplay`, { state: [id, cart] },);
  }
  const [cart, setCart] = useState([]);

  const cartAddRemove = (id) => {
    const newCart = [...cart];
    const index = newCart.indexOf(id);
    if (index > -1) {
      newCart.splice(index, 1);
    } else {
      newCart.push(id);
    }
    setCart(newCart);
  };

  const cartHandle = (id) => {
    props.cartHandle(id);
    cartAddRemove(id);
  }

  if (products.length === 0) {
    return <div className='flex justify-center items-center h-96'><div class="relative flex w-64 animate-pulse gap-2 p-4">
      <div class="h-12 w-12 rounded-full bg-slate-400"></div>
      <div class="flex-1">
        <div class="mb-1 h-5 w-3/5 rounded-lg bg-slate-400 text-lg"></div>
        <div class="h-5 w-[90%] rounded-lg bg-slate-400 text-sm"></div>
      </div>
      <div class="absolute bottom-5 right-0 h-4 w-4 rounded-full bg-slate-400"></div>
    </div></div>;
  }

  return (
    <>
      <div className='flex flex-row items-center justify-center align-middle uppercase text-xs italic products mt-8'>Get your best offers on ...</div>
      <div className='flex flex-row flex-wrap gap-3 items-center justify-center align-middle mt-2'>
        <div className="px-4 py-1 flex justify-center align-middle items-center text-gray-700 rounded-full text-xs italic products border ">MOBILES</div>
        <div className="px-4 py-1 flex justify-center align-middle items-center text-gray-700 rounded-full text-xs italic products border ">LAPTOPS</div>
        <div className="px-4 py-1 flex justify-center align-middle items-center text-gray-700 rounded-full text-xs italic products border ">FRAGRANCES</div>
        <div className="px-4 py-1 flex justify-center align-middle items-center text-gray-700 rounded-full text-xs italic products border ">SKIN CARE</div>
        <div className="px-4 py-1 flex justify-center align-middle items-center text-gray-700 rounded-full text-xs italic products border ">GROCERIES</div>
      </div>



      <div id='mobiles' className="products ">
        <span className="sm:ms-3 flex flex-row justify-center items-center align-middle uppercase text-sm sm:text-sm tracking-tight mt-10 mb-3  text-gray-700 gap-2 italic ">

          <FcFlashOn /> Top Deals on Mobiles !
          <span className="text-gray-950">Grab yours .. </span>
        </span>

        <div className="flex flex-wrap items-center justify-center gap-12 sm:gap-3 ">
          {products.map((product, index) => {
            if (product.category === "smartphones") {
              return (
                <div className=" animate-delay-0" >
                  <div
                    key={product.id}
                    className=" rounded translate-y-0 hover:-translate-y-4 sm:hover:-translate-y-4 ease-in-out duration-300  my-3 sm:mb-2 p-2 flex flex-col justify-center bg-white  border"
                  >
                    <div onClick={() => productPage(product.id)}
                      className=" rounded w-44 sm:w-36 h-32 animate-fade-right animate-delay-0 sm:h-28 bg-cover bg-center "
                      style={{ backgroundImage: `url(${product.thumbnail})` }}
                    ></div>

                    <div onClick={() => productPage(product.id)} className="font-normal italic mt-2 text-blue-950 sm:text-sm tracking-tight truncate w-40 sm:w-36 animate-delay-200 animate-fade-right ">
                      {product.title}
                    </div>
                    <div onClick={() => productPage(product.id)} className="inline-block  justify-start align-bottom animate-fade-right animate-delay-500">
                      <span className="text-xl  sm:text-xl font-semibold tracking-tighter text-gray-950 ">
                        ${product.price}
                      </span>
                      <span className="italic text-xs ms-2 text-red-950/80 ">

                        <span className="text-sm sm:text-xs text-red-1200 line-through">
                          ${product.discountPercentage} OFF
                        </span>
                      </span>
                    </div>
                    <div onClick={() => productPage(product.id)} className="flex flex-row items-start justify-between align-middle">
                      <span className="italic text-xs flex flex-row align-middle items-center animate-fade-right animate-delay-700">
                        <AiFillStar className="text-yellow-500" />
                        {product.rating}
                      </span>
                      <span className="flex sm:hidden flex-row text-xs border px-3 italic text-gray-400 border-gray-400">
                        ONLY {product.stock} LEFT
                      </span>
                    </div>
                    <div className="w-full mt-2 animate-fade-right animate-delay-1000">
                      {!props.cart.includes(product.id) ? (
                        <button
                          className="rounded text-md w-full text-gray-400 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-l from-gray-950 to-gray-800 animate-shake animate once shadow border-t border-t-gray-500 border-b-2 border-b-black "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineAddShoppingCart />
                        </button>
                      ) : (
                        <button
                          className="rounded text-md w-full text-gray-950 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-r from-gray-200 to-gray-400 animate-rotate-x animate once shadow border-t border-t-gray-100 border-b-2 border-b-gray-500 "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineRemoveShoppingCart />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>

      <div className="flex flex-col items-center justify-center">
        <img
          src={laptopbanner}
          className="rounded w-3/4 sm:w-full mb-6 sm:px-3"
          alt="Laptop Banner"
        />
      </div>

      {/* laptops */}
      <div className="products animate-fade animate-duration-[2000ms]">
        <span className="sm:ms-3 flex flex-row justify-center items-center align-middle uppercase text-sm sm:text-sm tracking-tight mt-10 mb-3  text-gray-700 gap-2 italic">
          <FcMultipleDevices /> Wanna Buy Laptops !{" "}
          <span className="text-gray-950">Let's gooo ..</span>
        </span>

        <div className="flex flex-wrap items-center justify-center gap-12 sm:gap-3 ">
          {products.map((product, index) => {
            if (product.category === "laptops") {
              return (
                <div className=" animate-delay-0">
                  <div
                    key={product.id}
                    className=" rounded translate-y-0 hover:-translate-y-4 sm:hover:-translate-y-4 ease-in-out duration-300  my-3 sm:mb-2 p-2 flex flex-col justify-center bg-white  border"
                  >
                    <div onClick={() => productPage(product.id)}
                      className=" rounded w-44 sm:w-36 h-32 animate-fade-right animate-delay-0 sm:h-28 bg-cover bg-center "
                      style={{ backgroundImage: `url(${product.thumbnail})` }}
                    ></div>

                    <div onClick={() => productPage(product.id)} className="font-normal italic mt-2 text-blue-950 sm:text-sm tracking-tight  truncate w-40 sm:w-36 animate-delay-200 animate-fade-right ">
                      {product.title}
                    </div>
                    <div onClick={() => productPage(product.id)} className="inline-block  justify-start align-bottom animate-fade-right animate-delay-500">
                      <span className="text-xl  sm:text-xl font-semibold tracking-tighter text-gray-950 ">
                        ${product.price}
                      </span>
                      <span className="italic text-xs ms-2 text-red-950/80 ">

                        <span className="text-sm sm:text-xs text-red-1200 line-through">
                          ${product.discountPercentage} OFF
                        </span>
                      </span>
                    </div>
                    <div onClick={() => productPage(product.id)} className="flex flex-row items-start justify-between align-middle">
                      <span className="italic text-xs flex flex-row align-middle items-center animate-fade-right animate-delay-700">
                        <AiFillStar className="text-yellow-500" />
                        {product.rating}
                      </span>
                      <span className="flex sm:hidden flex-row text-xs border px-3 italic text-gray-400 border-gray-400">
                        ONLY {product.stock} LEFT
                      </span>
                    </div>
                    <div className="w-full mt-2 animate-fade-right animate-delay-1000">
                      {!props.cart.includes(product.id) ? (
                        <button
                          className="rounded text-md w-full text-gray-400 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-l from-gray-950 to-gray-800 animate-shake animate once shadow border-t border-t-gray-500 border-b-2 border-b-black "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineAddShoppingCart />
                        </button>
                      ) : (
                        <button
                          className="rounded text-md w-full text-gray-950 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-r from-gray-200 to-gray-400 animate-rotate-x animate once shadow border-t border-t-gray-100 border-b-2 border-b-gray-500 "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineRemoveShoppingCart />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>

      {/* fragrances */}

      <div className="products animate-fade animate-duration-[2000ms]">
        <span className="sm:ms-3 flex flex-row justify-center items-center align-middle uppercase text-sm sm:text-sm tracking-tight mt-10 mb-3  text-gray-700 gap-2 italic">
          <FcAdvertising /> Fragance are here!{" "}
          <span className="text-gray-950">Wanna Buy ..</span>
        </span>


        <div className="flex flex-wrap items-center justify-center gap-12 sm:gap-3 ">
          {products.map((product, index) => {
            if (product.category === "fragrances") {
              return (
                <div className=" animate-delay-0">
                  <div
                    key={product.id}
                    className=" rounded translate-y-0 hover:-translate-y-4 sm:hover:-translate-y-4 ease-in-out duration-300  my-3 sm:mb-2 p-2 flex flex-col justify-center bg-white  border"
                  >
                    <div onClick={() => productPage(product.id)}
                      className=" rounded w-44 sm:w-36 h-32 animate-fade-right animate-delay-0 sm:h-28 bg-cover bg-center "
                      style={{ backgroundImage: `url(${product.thumbnail})` }}
                    ></div>

                    <div onClick={() => productPage(product.id)} className="font-normal italic mt-2 text-blue-950 sm:text-sm tracking-tight  truncate w-40 sm:w-36 animate-delay-200 animate-fade-right ">
                      {product.title}
                    </div>
                    <div onClick={() => productPage(product.id)} className="inline-block  justify-start align-bottom animate-fade-right animate-delay-500">
                      <span className="text-xl  sm:text-xl font-semibold tracking-tighter text-gray-950 ">
                        ${product.price}
                      </span>
                      <span className="italic text-xs ms-2 text-red-950/80 ">

                        <span className="text-sm sm:text-xs text-red-1200 line-through">
                          ${product.discountPercentage} OFF
                        </span>
                      </span>
                    </div>
                    <div onClick={() => productPage(product.id)} className="flex flex-row items-start justify-between align-middle">
                      <span className="italic text-xs flex flex-row align-middle items-center animate-fade-right animate-delay-700">
                        <AiFillStar className="text-yellow-500" />
                        {product.rating}
                      </span>
                      <span className="flex sm:hidden flex-row text-xs border px-3 italic text-gray-400 border-gray-400">
                        ONLY {product.stock} LEFT
                      </span>
                    </div>
                    <div className="w-full mt-2 animate-fade-right animate-delay-1000">
                      {!props.cart.includes(product.id) ? (
                        <button
                          className="rounded text-md w-full text-gray-400 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-l from-gray-950 to-gray-800 animate-shake animate once shadow border-t border-t-gray-500 border-b-2 border-b-black "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineAddShoppingCart />
                        </button>
                      ) : (
                        <button
                          className="rounded text-md w-full text-gray-950 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-r from-gray-200 to-gray-400 animate-rotate-x animate once shadow border-t border-t-gray-100 border-b-2 border-b-gray-500 "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineRemoveShoppingCart />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>

      {/* skincare */}

      <div className="products animate-fade animate-duration-[2000ms]">
        <span className="sm:ms-3 flex flex-row justify-center items-center align-middle uppercase text-sm sm:text-sm tracking-tight mt-10 mb-3  text-gray-700 gap-2 italic">
          <FcPortraitMode />
          Skin Care! <span className="text-gray-950">All at One Place ..</span>
        </span>


        <div className="flex flex-wrap items-center justify-center gap-12 sm:gap-3 ">
          {products.map((product, index) => {
            if (product.category === "skincare") {
              return (
                <div className=" animate-delay-0">
                  <div
                    key={product.id}
                    className=" rounded translate-y-0 hover:-translate-y-4 sm:hover:-translate-y-4 ease-in-out duration-300  my-3 sm:mb-2 p-2 flex flex-col justify-center bg-white  border"
                  >
                    <div onClick={() => productPage(product.id)}
                      className=" rounded w-44 sm:w-36 h-32 animate-fade-right animate-delay-0 sm:h-28 bg-cover bg-center "
                      style={{ backgroundImage: `url(${product.thumbnail})` }}
                    ></div>

                    <div onClick={() => productPage(product.id)} className="font-normal italic mt-2 text-blue-950 sm:text-sm tracking-tight  truncate w-40 sm:w-36 animate-delay-200 animate-fade-right ">
                      {product.title}
                    </div>
                    <div onClick={() => productPage(product.id)} className="inline-block  justify-start align-bottom animate-fade-right animate-delay-500">
                      <span className="text-xl  sm:text-xl font-semibold tracking-tighter text-gray-950 ">
                        ${product.price}
                      </span>
                      <span className="italic text-xs ms-2 text-red-950/80 ">

                        <span className="text-sm sm:text-xs text-red-1200 line-through">
                          ${product.discountPercentage} OFF
                        </span>
                      </span>
                    </div>
                    <div onClick={() => productPage(product.id)} className="flex flex-row items-start justify-between align-middle">
                      <span className="italic text-xs flex flex-row align-middle items-center animate-fade-right animate-delay-700">
                        <AiFillStar className="text-yellow-500" />
                        {product.rating}
                      </span>
                      <span className="flex sm:hidden flex-row text-xs border px-3 italic text-gray-400 border-gray-400">
                        ONLY {product.stock} LEFT
                      </span>
                    </div>
                    <div className="w-full mt-2 animate-fade-right animate-delay-1000">
                      {!props.cart.includes(product.id) ? (
                        <button
                          className="rounded text-md w-full text-gray-400 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-l from-gray-950 to-gray-800 animate-shake animate once shadow border-t border-t-gray-500 border-b-2 border-b-black "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineAddShoppingCart />
                        </button>
                      ) : (
                        <button
                          className="rounded text-md w-full text-gray-950 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-r from-gray-200 to-gray-400 animate-rotate-x animate once shadow border-t border-t-gray-100 border-b-2 border-b-gray-500 "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineRemoveShoppingCart />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
      {/* <Scrollcard/> */}

      <div className="flex flex-col items-center justify-center">
        <img
          src={shoebanner}
          className="rounded shadow w-3/4 sm:w-full mb-6  sm:px-3"
          alt="Laptop Banner"
        />
      </div>

      {/* groceries */}
      <div className="products animate-fade animate-duration-[2000ms]">
        <span className="sm:ms-3 flex flex-row justify-center items-center align-middle uppercase text-sm sm:text-sm tracking-tight mt-10 mb-3  text-gray-700 gap-2 italic">
          <FcInTransit />
          Book your Monthly Groceries..
        </span>


        <div className="flex flex-wrap items-center justify-center gap-12 sm:gap-3 ">
          {products.map((product, index) => {
            if (product.category === "groceries") {
              return (
                <div className=" animate-delay-0">
                  <div
                    key={product.id}
                    className=" rounded translate-y-0 hover:-translate-y-4 sm:hover:-translate-y-4 ease-in-out duration-300  my-3 sm:mb-2 p-2 flex flex-col justify-center bg-white  border"
                  >
                    <div onClick={() => productPage(product.id)}
                      className=" rounded w-44 sm:w-36 h-32 animate-fade-right animate-delay-0 sm:h-28 bg-cover bg-center "
                      style={{ backgroundImage: `url(${product.thumbnail})` }}
                    ></div>

                    <div onClick={() => productPage(product.id)} className="font-normal italic mt-2 text-blue-950 sm:text-sm tracking-tight  truncate w-40 sm:w-36 animate-delay-200 animate-fade-right ">
                      {product.title}
                    </div>
                    <div onClick={() => productPage(product.id)} className="inline-block  justify-start align-bottom animate-fade-right animate-delay-500">
                      <span className="text-xl  sm:text-xl font-semibold tracking-tighter text-gray-950 ">
                        ${product.price}
                      </span>
                      <span className="italic text-xs ms-2 text-red-950/80 ">

                        <span className="text-sm sm:text-xs text-red-1200 line-through">
                          ${product.discountPercentage} OFF
                        </span>
                      </span>
                    </div>
                    <div onClick={() => productPage(product.id)} className="flex flex-row items-start justify-between align-middle">
                      <span className="italic text-xs flex flex-row align-middle items-center animate-fade-right animate-delay-700">
                        <AiFillStar className="text-yellow-500" />
                        {product.rating}
                      </span>
                      <span className="flex sm:hidden flex-row text-xs border px-3 italic text-gray-400 border-gray-400">
                        ONLY {product.stock} LEFT
                      </span>
                    </div>
                    <div className="w-full mt-2 animate-fade-right animate-delay-1000">
                      {!props.cart.includes(product.id) ? (
                        <button
                          className="rounded text-md w-full text-gray-400 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-l from-gray-950 to-gray-800 animate-shake animate once shadow border-t border-t-gray-500 border-b-2 border-b-black "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineAddShoppingCart />
                        </button>
                      ) : (
                        <button
                          className="rounded text-md w-full text-gray-950 py-1 sm:py-2 text-center flex items-center justify-center  bg-gradient-to-r from-gray-200 to-gray-400 animate-rotate-x animate once shadow border-t border-t-gray-100 border-b-2 border-b-gray-500 "
                          onClick={() => cartHandle(product.id)}
                        >
                          <MdOutlineRemoveShoppingCart />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    </>
  );
};

export default Products;
